import * as React from 'react';
import {IOption, IOptionGroup} from "../../classes/seating-option";

interface ICheckbox {
    key: string;
    onChangeFunction: (SeatingOption: IOption) => any;
    checked: boolean;

    option: IOption;
    groupName: string;
}

class Checkbox extends React.PureComponent<ICheckbox, any> {
    render() {
        return (
            <li className="form-item">
                <input type="checkbox" className="checkbox-custom" name={this.props.groupName}
                    value={this.props.checked.toString()} id={this.props.option.id}
                    onChange={ () => { this.props.onChangeFunction(this.props.option) } }
                    checked={ this.props.checked }/>
                <label htmlFor={this.props.option.id}>{this.props.option.name}</label>
            </li>
        );
    }
}

export default Checkbox;